import { render, staticRenderFns } from "./CascaderField.vue?vue&type=template&id=645a62b5&scoped=true"
import script from "./CascaderField.vue?vue&type=script&lang=js"
export * from "./CascaderField.vue?vue&type=script&lang=js"
import style0 from "./CascaderField.vue?vue&type=style&index=0&id=645a62b5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/.pnpm/vue-loader@15.11.1_nl733cueh6kngwrfuxx6f6mp5u/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "645a62b5",
  null
  
)

export default component.exports